import { addDays, addMonths, endOfMonth, endOfWeek, startOfMonth, startOfQuarter, startOfWeek } from "date-fns";

export type IUsageData = {
	name: string;
	[key: string]: any;
};

export type IUsageSummary = {
	monthlyUsage: string | number;
	totalUsage: string | number;
};

export type ITableUsageRecord = {
	[key: string]: any;
};

export enum UsagePeriod {
	Daily = "day",
	Weekly = "week",
	Monthly = "month",
}

export enum UsageType {
	Playground = "Playground calls",
	API_PRODUCTION = "API - Production",
	API_STAGING = "API - Staging",
	Iframe = "Iframe calls",
	on_premise = "On-premise",
	ComfyUI = "ComfyUI calls",
	MCP = "MCP calls",
	FigmaPlugin = "Figma plugin calls",
	PhotoshopPlugin = "Photoshop plugin calls",
}

export const LineChartColors = [
	"#2A0067",
	"#5300C9",
	"#A43CFF",
	"#E4D4FF",
	"#FF3CA5",
	"#D80067",
	"#FFC847",
	"#C49991",
	"#FF9061",
	"#FFCAAC",
	"#78E3FD",
	"#109DBF",
	"#1B998B",
	"#2DD881",
	"#FFB6C1",
	"#FFA07A",
	"#FA8072",
	"#FF7F50",
	"#FF6347",
	"#FF4500",
	"#FFD700",
	"#FF8C00",
	"#FFA500",
	"#FFDAB9",
	"#FFDEAD",
	"#F0E68C",
	"#ADFF2F",
	"#7FFF00",
	"#32CD32",
	"#00FF00",
	"#98FB98",
	"#90EE90",
	"#00FA9A",
	"#00FF7F",
];

export const LineChartDefaultValues = [
	{
		name: "Jan",
		"text-to-vector/base/32": 0,
		"text-to-vector/base/23": 0,
		"text-to-vector/fast/23": 0,
		"text-to-image/base/32": 0,
		"text-to-image/base/22": 0,
		"text-to-image/base/23": 0,
		"text-to-image/fast/22": 0,
		"text-to-image/fast/23": 0,
		"text-to-image/hd": 0,
		replace_bg: 0,
		style: 0,
		expand: 0,
		increase_resolution: 0,
		image_to_psd: 0,
		"video/background/remove": 0,
		"video/edit/increase_resolution": 0,
		"background/remove": 0,
		"background/remove/guided": 0,
		"background/remove/prompt": 0,
		"background/blur": 0,
		search_similar_images: 0,
		reimagine: 0,
		refine_faces: 0,
		restyle_portrait: 0,
		eraser: 0,
		caption: 0,
		"product/cutout": 0,
		"product/packshot": 0,
		"product/integrate": 0,
		face: 0,
		prompt_enhancer: 0,
		"product/shadow": 0,
		"product/lifestyle_shot_by_text": 0,
		"product/lifestyle_shot_by_image": 0,
		erase_foreground: 0,
		crop_foreground: 0,
		gen_fill: 0,
		enhance_image: 0,
		"text-to-image/tailored": 0,
		"text-to-vector/tailored": 0,
		"image/generate": 0,
		"structured_prompt/generate": 0,
		"image-to-video/tailored": 0,
		"Text-To-Image/Fibo_lite": 0,
		"structured_prompt/generate-lite": 0,
		"video/edit/erase": 0,
		"ads/generate": 0,
		"structured_instruction/generate": 0,
		"image/edit": 0,
		"structured_prompt/generate_from_diff": 0,
		erase_by_text: 0,
		rewrite_text: 0,
		replace_object_by_text: 0,
		sketch_to_colored_image: 0,
		add_object_by_text: 0,
		reseason: 0,
		restyle: 0,
		colorize: 0,
		blend: 0,
		restore: 0,
		relight: 0,
		"vehicle/shot_by_text": 0,
		"vehicle/segment": 0,
		"vehicle/harmonize": 0,
		"vehicle/apply_effect": 0,
		"vehicle/refine_tires": 0,
		"vehicle/generate_reflections": 0,
		"image/segment/all_masks": 0,
		"lora/image/edit": 0,
		"video/edit/green_screen": 0,
		"video/edit/replace_background": 0,
		"video/segment/mask_by_prompt": 0,
		"video/segment/mask_by_key_points": 0,
		"video/generate/foreground_mask": 0,
		"vehicle/shot_by_image": 0,
		"product/holding": 0,
		"product/virtual_tryon": 0,
		"ads/delayer": 0,
	},
	{ name: "Feb" },
	{ name: "Mar" },
	{ name: "Apr" },
	{ name: "May" },
	{ name: "Jun" },
	{ name: "July" },
	{ name: "Aug" },
	{ name: "Sep" },
	{ name: "Oct" },
	{ name: "Nov" },
	{ name: "Dec" },
];

export const PredefinedDateRanges: any = [
	{
		label: "Today",
		value: [new Date(), new Date()],
		placement: "left",
	},
	{
		label: "Yesterday",
		value: [addDays(new Date(), -1), addDays(new Date(), -1)],
		placement: "left",
	},
	{
		label: "This week",
		value: [startOfWeek(new Date()), endOfWeek(new Date())],
		placement: "left",
	},
	{
		label: "This month",
		value: [startOfMonth(new Date()), new Date()],
		placement: "left",
	},
	{
		label: "Last month",
		value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
		placement: "left",
	},
	{
		label: "This quarter",
		value: [startOfQuarter(new Date()), new Date()],
		placement: "left",
	},
];
